module.exports = __webpack_public_path__ + "img/medialuna-dulce3.eaec812c.jpeg";